import api from './api';

export const holidayService = {
  getAll: async (location = null) => {
    const url = location ? `/holidays?location=${location}` : '/holidays';
    const response = await api.get(url);
    return response.data.holidays;
  },

  getById: async (id) => {
    const response = await api.get(`/holidays/${id}`);
    return response.data.holiday;
  },

  create: async (holidayData) => {
    const response = await api.post('/holidays', holidayData);
    return response.data.holiday;
  },

  update: async (id, holidayData) => {
    const response = await api.put(`/holidays/${id}`, holidayData);
    return response.data.holiday;
  },

  delete: async (id) => {
    const response = await api.delete(`/holidays/${id}`);
    return response.data;
  },

  batchUpload: async (holidays) => {
    const response = await api.post('/holidays/bulk', { holidays });
    return response.data;
  },
};
